<template>
  <div class="centerCensus">
    <div class="centerCensusItem">
      <img class="centerCensusImg" src="@/assets/centerCensus1.png" alt="">
      <div class="centerCensusItemNum">{{statisticsCount.addCompanyCount}}</div>
      <div class="centerCensusItemText">入驻企业</div>
    </div>
    <div class="centerCensusItem">
      <img class="centerCensusImg" src="@/assets/centerCensus2.png" alt="">
      <div class="centerCensusItemNum">{{statisticsCount.addMemberUserCount}}</div>
      <div class="centerCensusItemText">注册用户</div>
    </div>
    <div class="centerCensusItem">
      <img class="centerCensusImg" src="@/assets/centerCensus3.png" alt="">
      <div class="centerCensusItemNum">{{statisticsCount.admissionCount}}</div>
      <div class="centerCensusItemText">就业人数</div>
    </div>
    <div class="centerCensusItem">
      <img class="centerCensusImg" src="@/assets/centerCensus4.png" alt="">
      <div class="centerCensusItemNum">{{statisticsCount.addPositionCount}}</div>
      <div class="centerCensusItemText">新增岗位</div>
    </div>
    <div class="centerCensusItem">
      <img class="centerCensusImg" src="@/assets/centerCensus5.png" alt="">
      <div class="centerCensusItemNum">{{statisticsCount.addProjectCount}}</div>
      <div class="centerCensusItemText">项目数量</div>
    </div>
  </div>
</template>

<script>
import { getStatisticsCountApi } from '@/utils/api'

export default {
  data() {
    return {
      statisticsCount:''
    }
  },
  mounted() {
    this.getStatisticsCount()
  },
  methods: {

    async getStatisticsCount(data) {
      await getStatisticsCountApi({
        ...data
      }).then(res => {
        this.statisticsCount = res.data.data
      })
    },
  }

}
</script>

<style lang="scss" scoped>
.centerCensus {
  width: 735px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .centerCensusItem {
    position: relative;

    .centerCensusImg {
      width: 105px;
      height: 118px;
      margin-bottom: 15px;
    }

    .centerCensusItemText {
      font-size: 17px;
      color: #FFFFFF;
      text-align: center;
    }

    .centerCensusItemNum {
      position: absolute;
      top: 8px;
      left: 50%;
      transform: translateX(-50%);
      font-weight: bold;
      font-size: 20px;
      color: #FFFFFF;
    }
  }
}
</style>
